import { useBlocksConfig } from "@pathwright/blocks-engine"
import { BlockText } from "@pathwright/blocks/src/shared"
import { loadIframely } from "@pathwright/media-utils"
import React from "react"
import { EmbedWrapper } from "./ui"

const EmbedDisplay = ({ layout, embedCode }) => {
  const { templateVariables } = useBlocksConfig()

  React.useEffect(() => {
    loadIframely()
  }, [embedCode])

  const aspect = layout === "video" || layout === "video_embed" ? "16:9" : ""

  return (
    <EmbedWrapper aspect={aspect} className="EmbedBlockDisplay">
      <BlockText
        className="EmbedBlockDisplay__container"
        html={embedCode}
        templateContext={templateVariables}
      />
    </EmbedWrapper>
  )
}

export default EmbedDisplay
